import type { analyticsMap } from "../../../../api/interfaces/analyticsMap";
import type { CallCenterModel } from "../../../../api/interfaces/callCenterModel";

type CallCenterPartial =
  Pick<
    CallCenterModel,
    | 'showPreviousOrderDays'
    | 'statusForOrdersNotShown'
    | 'maxNoOfOrders'
  >;
export type IOrderDetails = CallCenterPartial & analyticsMap

export const IOrderDetailsKeys: (keyof IOrderDetails)[] = [
  'pageName',
  'showPreviousOrderDays',
  'statusForOrdersNotShown',
  'maxNoOfOrders',
];
